export const UpdateUnlimitedTargetMap = {
  // 升级unlimited弹窗相关
  UpdateUnlimitedDialogShow_side: "UpdateUnlimitedDialogShow_side", // 升级unlimited弹窗展示-侧边栏
  UpdateUnlimitedDialogShow_card: "UpdateUnlimitedDialogShow_card", // 升级unlimited弹窗展示-卡片
  UpdateUnlimitedDialogShow_career: "UpdateUnlimitedDialogShow_career", // 升级unlimited弹窗展示-领英生态外侧边栏
  UpdateUnlimitedDialogShow_finder: "UpdateUnlimitedDialogShow_finder", // 升级unlimited弹窗展示-查找页
  UpdateUnlimitedDialogShow_contacts: "UpdateUnlimitedDialogShow_contacts", // 升级unlimited弹窗展示-联系人

  UpdateUnlimitedDialogClickUpgrade_side:
    "UpdateUnlimitedDialogClickUpgrade_side", // 升级unlimited弹窗点击升级-侧边栏
  UpdateUnlimitedDialogClickUpgrade_card:
    "UpdateUnlimitedDialogClickUpgrade_card", // 升级unlimited弹窗点击升级-卡片
  UpdateUnlimitedDialogClickUpgrade_career:
    "UpdateUnlimitedDialogClickUpgrade_career", // 升级unlimited弹窗点击升级-领英生态外侧边栏
  UpdateUnlimitedDialogClickUpgrade_finder:
    "UpdateUnlimitedDialogClickUpgrade_finder", // 升级unlimited弹窗点击升级-查找页
  UpdateUnlimitedDialogClickUpgrade_contacts:
    "UpdateUnlimitedDialogClickUpgrade_contacts", // 升级unlimited弹窗点击升级-联系人

  UpdateUnlimitedFailedClickEmail_side: "UpdateUnlimitedFailedClickEmail_side", // 升级unlimited失败点击联系邮箱-侧边栏
  UpdateUnlimitedFailedClickEmail_card: "UpdateUnlimitedFailedClickEmail_card", // 升级unlimited失败点击联系邮箱-卡片
  UpdateUnlimitedFailedClickEmail_career:
    "UpdateUnlimitedFailedClickEmail_career", // 升级unlimited失败点击联系邮箱-领英生态外侧边栏
  UpdateUnlimitedFailedClickEmail_finder:
    "UpdateUnlimitedFailedClickEmail_finder", // 升级unlimited失败点击联系邮箱-查找页
  UpdateUnlimitedFailedClickEmail_contacts:
    "UpdateUnlimitedFailedClickEmail_contacts", // 升级unlimited失败点击联系邮箱-联系人

  UpdateUnlimitedFailedClose_side: "UpdateUnlimitedFailedClose_side", // 升级unlimited失败关闭弹窗-侧边栏
  UpdateUnlimitedFailedClose_card: "UpdateUnlimitedFailedClose_card", // 升级unlimited失败关闭弹窗-卡片
  UpdateUnlimitedFailedClose_career: "UpdateUnlimitedFailedClose_career", // 升级unlimited失败关闭弹窗-领英生态外侧边栏
  UpdateUnlimitedFailedClose_finder: "UpdateUnlimitedFailedClose_finder", // 升级unlimited失败关闭弹窗-查找页
  UpdateUnlimitedFailedClose_contacts: "UpdateUnlimitedFailedClose_contacts", // 升级unlimited失败关闭弹窗-联系人
};
